/**
 * Get Active Sessions Use Case
 * Fetches currently active charging sessions
 */

import { DashboardRepository } from '../data/dashboard-repository';
import { ActiveSession } from '../types/dashboard-types';

export class GetActiveSessionsUseCase {
  constructor(private readonly repository: DashboardRepository) {}

  async execute(): Promise<{
    sessions: ActiveSession[];
    totalCount: number;
    totalEnergy: number;
    totalRevenue: number;
    hasError: boolean;
    errorMessage?: string;
  }> {
    try {
      const result = await this.repository.getActiveSessions();

      // Sort by duration (longest first)
      const sortedSessions = [...result.sessions].sort(
        (a, b) => b.durationMinutes - a.durationMinutes
      );

      return {
        sessions: sortedSessions,
        totalCount: sortedSessions.length,
        totalEnergy: result.totalActiveEnergy,
        totalRevenue: result.totalActiveRevenue,
        hasError: false,
      };
    } catch (error) {
      console.error('GetActiveSessionsUseCase.execute failed:', error);

      return {
        sessions: [],
        totalCount: 0,
        totalEnergy: 0,
        totalRevenue: 0,
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to load active sessions',
      };
    }
  }
}
